import { render, staticRenderFns } from "./DaysOffEditor.vue?vue&type=template&id=05c0d4c4"
import script from "./DaysOffEditor.vue?vue&type=script&lang=js"
export * from "./DaysOffEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports